<!-- Se servissero finestre non warning va modificato qui il class -->
<h1 mat-dialog-title class="se-dialog-header-warning mat-elevation-z6 header-text-editor-dialog">
    {{ data.title | translate }}
</h1>

<div mat-dialog-content class="container-content-text-editor-dialog" >
    <div class="content-text-editor-dialog">
        {{ data.description | translate }}
    </div>
    
</div>

<div mat-dialog-actions class="actions-text-editor-dialog" >
    @if (data.buttonNo) {
        <button mat-button [mat-dialog-close]="false">{{ 'No' | translate }}</button>
    }
    @if (data.buttonYes) {
        <button mat-button color="primary" [mat-dialog-close]="true">{{ 'Yes' | translate }}</button>
    }
</div>
